<template>
    <div class="tickets">
        <form @submit.prevent="search()" class="main-form">
            <custom-input v-model="cardName" :title="$t('CBCX_TICKETS__CARD_NAME')" @clear="cardName = ''" :isRequired=true />
            <custom-input v-model="ticketID" :title="$t('CBCX_TICKETS__TICKET_ID')" @clear="ticketID = ''" />
            <button class="btn">{{ $t('CBCX_TICKETS__SEARCH') }}</button>
        </form>
        <grid
            :fullGrid="true"
            :passedData="gridData"
            identificator="id"
            :columns="columns"
            :passedCount="dataCount"
            :passedPageSize="15"
            :title="$t('CBCX_TICKETS__TICKETS')"
            @trClicked="trClickHandler"
            @pageChanged="pageChangeHandler"
            class="tickets-grid"
        ></grid>
        <ticket-details 
            :visible="showTicketDetailsPopup"
            :details="ticketInfo"
            :basicInfo="selectedTicket"
            @close="showTicketDetailsPopup = false"
        />
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import TicketDetails from './TicketDetails.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { addHours } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        CustomInput, Grid, TicketDetails,
    },
    data() {
        return {
            cardName: '',
            ticketID: '',
            gridData: [],
            dataCount: 0,
            columns: [
                {
                    title: this.$t('CBCX_TICKETS__TICKET_ID'),
                    key: 'ticketId',
                },
                {
                    title: this.$t('CBCX_TICKETS__APPLICATION'),
                    key: 'application',
                },
                {
                    title: this.$t('CBCX_TICKETS__CREATE_DATE'),
                    key: 'createDate',
                    customTemplate: (item, val) => addHours(val, 2),
                    dontShowOnHover: true,
                },
                {
                    title: this.$t('CBCX_TICKETS__USER_ID'),
                    key: 'userProfileId',
                },
                {
                    title: this.$t('CBCX_TICKETS__BET_AMOUNT'),
                    key: 'betAmount',
                    customTemplate: (item, val) => val ? val + ' ' + item.currencyCode : 0,
                    dontShowOnHover: true,
                },
                {
                    title: this.$t('CBCX_TICKETS__WIN_AMOUNT'),
                    key: 'wonAmount',
                    customTemplate: (item, val) => val ? val + ' ' + item.currencyCode : 0,
                    dontShowOnHover: true,
                },
                {
                    title: this.$t('CBCX_TICKETS__STATION_ID'),
                    key: 'stationId',
                },
                {
                    title: this.$t('CBCX_TICKETS__IS_TERMINAL'),
                    key: 'isTerminal',
                    customTemplate: (item, val) => val ? 'YES' : 'NO'
                },
                // {
                //     title: '',
                //     key: '',
                //     customTemplate: () => `<button class="btn details btn-filter">${this.$t('CBCX_TICKETS__IS_DETAILS')}</button>`
                // }
            ],
            ticketInfo: null,
            showTicketDetailsPopup: false,
            selectedTicket: {},
        }
    },
    methods: {
        search(page) {
            axios
                .get('WebShop/GetCBCXTickets', { params: {
                    AccountCardName: this.cardName,
                    TicketID: this.ticketID,
                    OrderColumn: 'id',
                    OrderDirection: 'desc',
                    CurrentPage: page || 1,
                    PageSize: 15,
                }})
                .then(resp => {
                    if(resp.data.status != 1) return
                    this.gridData = resp.data.response
                    this.dataCount = resp.data.response[0] ? resp.data.response[0].count : 0
                })
        },
        pageChangeHandler(page) {
            this.search(page)
        },
        trClickHandler(element) {
            axios
                .get('WebShop/GetXliveBetDetails', {params: {
                    UserProfileId: element.userProfileId,
                    TicketId: element.ticketId,
                }})
                .then(resp => {
                    if(resp.data.status != 1) return
                    this.ticketInfo = resp.data.response
                    this.selectedTicket = element
                    this.showTicketDetailsPopup = true
                })
        },
    }, 
}
</script>

<style scoped lang="scss">
form {
    margin-bottom: 15 * $rem;
}

/deep/ .btn-filter {
    margin-right: 15 * $rem;
}

/deep/ .tickets-grid tr {
    cursor: pointer;
}

</style>